import { headersWithToken } from '@shared/Frontend/utils/headersWithToken'
import { Maybe } from 'ballerina-core'
import i18next from 'i18next'
import { cmsImageParser, gridSrcSet, recentsSrcSet } from '../../shared/cmsImage/cmsImage.parser'
import { PageInfoResponse, PageResponse } from '../cmsPage.parser'
import { Category } from '../cmsPage.state'
import { Teaser, TeaserKind, Teasers } from './teasers.state'
import { FiltersMap } from '../filters/filters.state'

export type TeaserOpts = {
  type: TeaserKind,
  page?: number,
  pageSize?: number,
  slug?: string,
  filters?: FiltersMap
}

export const getTeasers = async ({ type, page = 1, pageSize = 12, slug = '', filters }: TeaserOpts): Promise<Maybe<Teasers>> => {
  const headers = headersWithToken()
  headers.append('content-type', 'application/json')

  const response = await fetch(`/api/overview/${type}`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ locale: i18next.language, page, pageSize, slug, filters }),
  })

  try {
    const json: TeasersResponse = await response.json()

    const items = json.rows.map(
      (item): Teaser => ({
        id: item.id,
        title: item.teaserInfo?.title ?? item.headerInfo.title ?? item.pageTitle,
        intro: item.teaserInfo?.introduction ?? item.headerInfo.introduction,
        kind: item.kind,
        link: { title: item.teaserInfo?.title ?? item.headerInfo.title ?? item.pageTitle, url: item.absolutePath },
        categories: item.categories,
        publicationDate: item.publicationDate ? new Date(item.publicationDate) : undefined,
        image: Maybe.Operations.map(cmsImageParser(type == 'news' ? gridSrcSet : recentsSrcSet))(item.teaserInfo?.image ?? item.headerInfo?.image),
      })
    )

    return { items: items, totalCount: json.totalItems, totalPages: json.totalPages }
  } catch {
    return undefined
  }
}

type TeasersResponse = {
  rows: Array<{
    id: string
    slug: string
    absolutePath: string
    pageTitle: string
    kind: PageResponse['kind']
    headerInfo: PageInfoResponse
    teaserInfo?: PageInfoResponse
    publicationDate?: string
    categories?: Category[]
  }>
  totalItems: number
  totalPages: number
}
